import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';
import { AccountInformationComponent } from './pages/account-information/account-information.component';

const components = [AccountComponent, AccountInformationComponent];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AccountRoutingModule,
    CdkAccordionModule,
    MatIconModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  declarations: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountModule {}
